// extracted by mini-css-extract-plugin
export default {"chats":"Chat_chats__ZDMri","chatBox":"Chat_chatBox__hiupi","changeSizeBtn":"Chat_changeSizeBtn__5jH51"};